import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintPermohonanKPRSubsidi = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocPermohonanKPRSubsidi = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          SURAT PERNYATAAN PEMOHON KPR BERSUBSIDI BTN
        </div>

        <div style={{ padding: "10px" }}>
          <div style={{ marginTop: "10px" }}>Yang bertanda tangan di bawah ini:</div>
          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr>
                <td>Tempat/Tanggal Lahir</td>
                <td>:</td>
                <td>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? ""}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td>:</td>
                <td>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr>
                <td>No. KTP/NIK</td>
                <td>:</td>
                <td>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat</td>
                <td>:</td>
                <td>{item.sls_appl?.address ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginBottom: "20px" }}>Selaku Pemohon.</div>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td>Tempat/Tanggal Lahir</td>
                <td>:</td>
                <td>
                  {item.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(item.sls_appl?.birthat_spouse) ?? ""}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td>:</td>
                <td>{item.sls_appl?.job_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td>No. KTP/NIK</td>
                <td>{item.sls_appl?.identity_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat</td>
                <td>:</td>
                <td>{item.sls_appl?.address_spouse ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginBottom: "20px" }}>Selaku suami/istri* pemohon.</div>

          <div style={{ marginTop: "20px" }}>Menyatakan dengan sesungguhnya bahwa:</div>
          <ol style={{ paddingLeft: "15px" }}>
            <li>Saya memiliki gaji/upah pokok/penghasilan bersih/upah rata – rata *) per bulan sebesar Rp. ................................,- (................................)</li>
            <li>Saya dan (istri/suami*)) tidak memiliki hak kepemilikan atas rumah pada saat pengajuan pembiayaan KPR Bersubsidi.</li>
            <li>Saya dan (istri/suami*)) belum pernah menerima subsidi atau bantuan pembiayaan perumahan dari pemerintah terkait kredit/pembiayaan perumahan dari pemerintah terkait kredit/pembiayaan kepemilikan rumah dan pembangunan Rumah Swadaya.</li>
            <li>Saya membeli Rumah Umum Tapak/Sarusun Umum dengan harga Rp ............................................. ,- (........................................................) dari PT................................</li>
            <li>Saya dan (istri/suami*)) akan menggunakan Rumah Umum Tapak/Sarusun Umum sebagai tempat tinggal saya dan/atau keluarga dalam kurun waktu paling lambat 1 (satu) tahun setelah serah terima rumah.</li>
            <li>
              Saya dan (istri/suami*)) tidak akan menyewakan/mengontrakkan, memperjualbelikan atau memindahtangankan dengan bentuk perbuatan hukum apapun, kecuali:
              <br />
              <ol type="a" style={{ paddingLeft: "15px" }}>
                <li>penghunian telah melampaui 5 (lima) tahun untuk Rumah Umum Tapak;</li>
                <li>penghunian telah melampaui 20 (dua puluh) tahun untuk Sarusun Umum;</li>
                <li>pindah tempat tinggal sesuai ketentuan peraturan perundang-undangan; atau</li>
                <li>meninggal dunia (pewarisan); atau</li>
                <li>untuk kepentingan Bank BTN dalam rangka penyelesaian kredit bermasalah.</li>
              </ol>
            </li>
            <li>Bahwa semua dokumen persyaratan yang disampaikan kepada Bank BTN untuk memperoleh subsidi adalah benar dan dapat dipertanggungjawabkan keabsahannya.</li>
            <li>Apabila di kemudian hari pernyataan saya ini tidak benar dan/atau tidak saya penuhi, saya bersedia mengembalikan seluruh dana kemudahan dan/atau bantuan pembiayaan perumahan yang telah diperoleh melalui Bank BTN dan bersedia dikenakan sanksi sesuai dengan ketentuan peraturan perundang- undangan.</li>
          </ol>
          <p>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "70%",
              border: "1px solid black",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    width: "50%",
                    textAlign: "center",
                  }}
                >
                  Menyetujui,
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    textAlign: "center",
                  }}
                >
                  ......................, tanggal ................ 20...
                  <br />
                  <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                  <br /> <br /> <br /> <br />
                </td>
              </tr>

              {/* Kotak Materai */}
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "28px 12px 8px 12px",
                    verticalAlign: "top",
                  }}
                >
                  {/* Kosong untuk tanda tangan kiri */}
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    verticalAlign: "middle",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      border: "1px solid black",
                      width: "140px",
                      height: "80px",
                      top: "-50px",
                      left: "50%",
                      padding: "10px",
                      fontSize: "12px",
                      textAlign: "center",
                      position: "absolute",
                      transform: "translateX(-50%)",
                      backgroundColor: "white",
                    }}
                  >
                    Meterai
                    <br />
                    Rp. 10.000,-
                  </div>
                </td>
              </tr>

              {/* Baris tanda tangan */}
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  <br />
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  {item.sls_appl?.name ?? "-"}
                </td>
              </tr>

              {/* Baris Mengetahui */}
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid black",
                    padding: "12px",
                    textAlign: "center",
                  }}
                >
                  Mengetahui,
                  <br />
                  Pimpinan Tempat Bekerja/Kepala Desa/Lurah* ......................................................
                </td>
              </tr>

              {/* Baris tanda tangan bawah */}
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid black",
                    padding: "60px 12px 20px 12px",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  Nama Lengkap, Jabatan dan Stempel
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p>*) coret salah yang tidak perlu</p>
      </div>
    </div>
  );
};
